import { Container, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import Plans from '../../components/Plans/Plans';

export default function Section5() {
  const { t } = useTranslation();
  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column' },
        justifyContent: 'center',
        alignItems: 'center',
        py: { xs: 8, md: 10 },
      }}
      maxWidth="lg"
    >
      <Stack gap={2} sx={{ width: '100%' }}>
        <Stack component={'header'} gap={2}>
          <Typography
            variant="h2"
            sx={{ fontSize: '32px', fontWeight: '600', textAlign: 'center' }}
          >
            {t('HOME_PAGE.SECTION5.TITLE')}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: 'text.secondary',
              fontSize: '16px',
              fontWeight: '300',
              textAlign: 'center',
            }}
          >
            {t('HOME_PAGE.SECTION5.PARAGRAPH')}
          </Typography>
        </Stack>
        <Plans />
      </Stack>
    </Container>
  );
}
